import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';


@Component({
    selector: 'eas-editor-booking-item-setting-field-capacity-available',
    templateUrl: './editor-booking-item-setting-field-capacity-available.component.html',
    standalone: false
})
export class EditorBookingItemSettingFieldCapacityAvailableComponent implements OnInit {
  @Input() parentFormGroup: FormGroup;

  constructor() {

  }

  ngOnInit() {

  }
}
